import React, { type JSX } from 'react'
import classNames from 'classnames'
import SvgDelivery from '../../svg/delivery-2.svg'
import { IconProps } from '../icon-props'

const DeliveryIcon = ({
  className = '',
  multiLayered = false,
  ...props
}: IconProps): JSX.Element | null => (
  <SvgDelivery
    {...props}
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    className={classNames('i-delivery', className, {
      'i-multi-layered': multiLayered,
    })}
  />
)

export default DeliveryIcon
